import RootRoutes from './routes'

function App() {
	return <RootRoutes />
}

export default App
